/*
  Vocabulário das assinaturas no painel. Os rótulos vêm do servidor; aqui só a cor,
  e a lista de abas, que não depende de nenhuma assinatura para existir.
*/
export const STATUS_TONES = {
  PENDING: "warning",
  ACTIVE: "success",
  OVERDUE: "danger",
  CANCELLED: "neutral",
  EXPIRED: "neutral",
};

export const STATUS_TABS = [
  { value: "", label: "Todas" },
  { value: "ACTIVE", label: "Ativas" },
  { value: "PENDING", label: "Aguardando 1º pagamento" },
  { value: "OVERDUE", label: "Em atraso" },
  { value: "CANCELLED", label: "Canceladas" },
  { value: "EXPIRED", label: "Encerradas" },
];

export const CHARGE_TONES = {
  CONFIRMED: "success",
  RECEIVED: "success",
  RECEIVED_IN_CASH: "success",
  PENDING: "warning",
  OVERDUE: "danger",
  CHARGEBACK_REQUESTED: "danger",
  REFUNDED: "neutral",
  DELETED: "neutral",
};

export const isLiveSubscription = (subscription) =>
  ["PENDING", "ACTIVE", "OVERDUE"].includes(subscription?.status);
